export * from './angularx-qrcode';
